<template>
  <div class="container my-5">
    <!-- Hauptkacheln (Kunden, Verkauf, Artikel, Admin) -->
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 col-lg-4 mb-4">
        <div @click="goToMenu('customers')" :class="['modern-tile', { 'active-tile': activeMenu === 'customers' }]">
          <div class="tile-content">
            <font-awesome-icon icon="users" class="tile-icon" />
            <span class="tile-title">KUNDEN</span>
          </div>
        </div>
      </div>
      
      <div class="col-12 col-md-6 col-lg-4 mb-4">
        <div @click="goToMenu('sales')" :class="['modern-tile', { 'active-tile': activeMenu === 'sales' }]">
          <div class="tile-content">
            <font-awesome-icon icon="cash-register" class="tile-icon" />
            <span class="tile-title">VERKAUF</span>
          </div>
        </div>
      </div>
      
      <div class="col-12 col-md-6 col-lg-4 mb-4">
        <div @click="goToMenu('items')" :class="['modern-tile', { 'active-tile': activeMenu === 'items' }]">
          <div class="tile-content">
            <font-awesome-icon icon="box" class="tile-icon" />
            <span class="tile-title">ARTIKEL</span>
          </div>
        </div>
      </div>
      
      <!-- Neue Admin-Kachel -->
      <div class="col-12 col-md-6 col-lg-4 mb-4">
        <div @click="goToMenu('admin')" :class="['modern-tile', { 'active-tile': activeMenu === 'admin' }]">
          <div class="tile-content">
            <font-awesome-icon icon="user-cog" class="tile-icon" />
            <span class="tile-title">ADMIN</span>
          </div>
        </div>
      </div>
       <!-- NEU: Analyse-Kachel -->
       <div class="col-12 col-md-6 col-lg-4 mb-4">
        <div @click="goToMenu('analysis')" :class="['modern-tile', { 'active-tile': activeMenu === 'analysis' }]">
          <div class="tile-content">
            <font-awesome-icon icon="chart-line" class="tile-icon" />
            <span class="tile-title">ANALYSE</span>
          </div>
        </div>
      </div>

      
    </div>
  </div>
</template>

<script>
import { authState as auth } from '../auth';

export default {
  data() {
    return {
      activeMenu: null,
    };
  },
  mounted() {
    auth.checkAuthStatus();
    if (!auth.isAuthenticated) {
      this.$router.push('/login');
    }
  },
  methods: {
  goToMenu(menu) {
    this.activeMenu = menu;

    if (menu === 'customers') {
      this.$router.push('/customers');
    } else if (menu === 'items') {
      this.$router.push('/items');
    } else if (menu === 'sales') {
      this.$router.push('/sales');
    } else if (menu === 'admin') {
      this.$router.push('/admin');
    } else if (menu === 'analysis') {
      this.$router.push('/analysis');
    }
  },
},

};
</script>

<style scoped>
.modern-tile {
  background-color: var(--primary-color);
  color: white;
  padding: 20px;
  border-radius: 20px;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  text-align: center;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  position: relative;
}

.tile-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tile-title {
  font-size: 24px;
  font-weight: bold;
  margin-top: 10px;
}

.tile-icon {
  font-size: 48px;
}

.active-tile {
  background-color: var(--secondary-color);
  transform: translateY(-5px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2);
}

.modern-tile:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2);
}
</style>
